import uniqId from 'lodash/uniqueId';

import BaseModel from '../base';

export default class TournamentStage extends BaseModel {
  constructor(stage, url) {
    super(stage, url);

    this.id = stage.id || uniqId();
    this.name = stage.name || '';
    this.description = stage.description || '';

    this.tournament_id = stage.tournament_id;
    this.parent_id = stage.parent_id;

    this.groups = [];
  }

  setGroups(list) {
    this.groups = [list].flat();
  }
}
